import { Button, Form, Input, Select, notification } from "antd";
import "./style.css";
import React, { useState } from "react";
import { IoLocationSharp } from "react-icons/io5";
import LocationModal from "../../../../Components/LocationModal";
import RouteMap from "../RouteMap";
import { getRecommendedFuelPumps } from "../../../../API/decisionEngine";

const Option = Select;

const RecommendedFuelPumps = ({
  vehicles,
  from,
  to,
  startValue,
  endValue,
  setStartValue,
  setEndValue,
  setPumps,
  selectedPump,
  setIsPumpSuggested,
  setIsPumpLoading,
}) => {
  const [openStartLocationModal, setStartOpenLocationModal] = useState(false);
  const [openEndLocationModal, setEndOpenLocationModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState("")

  const handleLocationModalStart = () => {
    setStartOpenLocationModal(true);
  };

  const handleLocationModalEnd = () => {
    setEndOpenLocationModal(true);
  };

  const handleFindPumps = async (values) => {
    setIsPumpLoading(true)
    try {
      if (!startValue || !endValue) {
        notification.error({
          key: "Error",
          message: "Error",
          description: "Select Origin And Destination",
          placement: "topRight",
        });
      }

      const response = await getRecommendedFuelPumps(to, from, startValue, endValue, selectedVehicle)
      setPumps(response?.data?.fuel_suggestions)
      setIsPumpSuggested(response?.data?.stations_suggested)
    } catch (error) {
      notification.error({
        key: "Error",
        message: "Error",
        description: "Failed to fetch pumps:",
        placement: "topRight",
      });
    }
    setIsPumpLoading(false)
  };

  return (
    <div className="recommended-fuel-pumps">
      <Form onFinish={handleFindPumps}>
        <div className="ant-form2">
          <Form.Item
            name="start"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                value={startValue}
                readOnly
                placeholder={"Starting Point..."}
                style={{ marginRight: "8px" }}
              />
              <Button
                icon={<IoLocationSharp />}
                onClick={handleLocationModalStart}
              />
            </div>
          </Form.Item>

          <Form.Item
            name="destination"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                value={endValue}
                readOnly
                placeholder={"Destination..."}
                style={{ marginRight: "8px" }}
              />
              <Button
                className="end-btn"
                icon={<IoLocationSharp />}
                onClick={handleLocationModalEnd}
              />
            </div>
          </Form.Item>
        </div>

        <div className="ant-form2">
          <Form.Item
            name="vehicle"
            rules={[
              {
                required: true,
                message: "Please select a vehicle!",
              },
            ]}
          >
            <Select
              popupClassName="custom-select-dropdown"
              placeholder="Select Vehicle"
              onChange={setSelectedVehicle}
            >
              {vehicles.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div>
            <Form.Item>
              <Button htmlType="submit">Find</Button>
            </Form.Item>
          </div>
        </div>
      </Form>

      <RouteMap startValue={startValue} endValue={endValue} selectedPump
        ={selectedPump} />

      <LocationModal
        open={openStartLocationModal}
        setOpen={setStartOpenLocationModal}
        setLocation={setStartValue}
      />

      <LocationModal
        open={openEndLocationModal}
        setOpen={setEndOpenLocationModal}
        setLocation={setEndValue}
      />
    </div>
  );
};

export default RecommendedFuelPumps;
